import React, { useEffect, useState } from "react";
import lab1 from "../../assets/icons/lab1.webp";
import TimeCard from "../../components/TimeCard";
import { logout } from "../../features/authSlice";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CommonTitle from "../../components/CommonTitle";
import DateAndTimeBar from "../../components/DateAndTimeBar";

const LabRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user); // Traemos al usuario del estado global

  const tokenExp = localStorage.getItem("tokenExp"); // Se extrae el token del localStorage

  const isTokenExpired = () => {
    // Verifica si el token expiró
    const expTime = tokenExp;
    if (!expTime) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return parseInt(expTime) < currentTime;
  };

  useEffect(() => {
    // Si el token expira se le envía al usuario al login (Cada token dura 48 horas)
    if (isTokenExpired()) {
      dispatch(logout());
      navigate("/");
    }
  }, []);

  if (user == null) {
    // Si no hay usuario logeado se le envía al login
    return <Navigate to={"/"} />;
  }

  return (
    <div className="flex bg-light-green flex-col  h-full">
      <CommonTitle
        img={lab1}
        title={"Registro de laboratorio"}
        text={
          "El procedimiento de toma de datos se toman en 4 tiempos durante el día."
        }
      />

      <DateAndTimeBar />

      {/* Cardcontainer */}
      <div className="flex w-full justify-center bg-light-green h-fit">
        <div className="flex flex-wrap max-w-[1280px] 2xl:max-w-[1920px]  w-full justify-center md:p-6 p-1 h-full">
          <TimeCard text={"Madrugada"} />
          <TimeCard text={"Mañana"} />
          <TimeCard text={"Tarde"} />
          <TimeCard text={"Noche"} />
        </div>
      </div>
    </div>
  );
};

export default LabRegister;
